import { render, staticRenderFns } from "./passed-badge.vue?vue&type=template&id=65fc5b52&scoped=true"
import script from "./passed-badge.vue?vue&type=script&lang=js"
export * from "./passed-badge.vue?vue&type=script&lang=js"
import style0 from "./passed-badge.vue?vue&type=style&index=0&id=65fc5b52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fc5b52",
  null
  
)

export default component.exports